import { z } from "zod";
import { MessageSchema } from "./Message";

export type ModelMessageConnection = z.infer<typeof ModelMessageConnectionSchema>;
export const ModelMessageConnectionSchema = z.object({
  items: z.array(MessageSchema),
  nextToken: z.string().nullable(),
});
